import React, {useEffect, useState} from "react";
import PaymentCardForm from "../../components/Cards/PaymentCardForm";
import {useParams} from "react-router-dom";
import {getBankInformation, getPaymentReceipt, postPayment} from "../../services/payment-service";
import Swal from "sweetalert2";

export default function PaymentGateway(props) {

    //Formik values for card form
    let cardValues = {
        bankId:"",
        cardNumber: '',
        ownerCardName: '',
        dateEndMM: null,
        dateEndYY: null,
        cvv: null
    }

    let [receiptData, setReceiptData] = useState({});
    const [showError, setShowError] = useState(true);

    //Getting receiptId from the route of the page
    const {receiptId} = useParams();

    //When the component starts...
    useEffect(() => {
        //Llamando a la información del banco
        //Calling the service consulting by receiptId...
        getPaymentReceipt(receiptId).then(data => {
            setShowError(false);
            //Saving the response in the state.
            setReceiptData(data);
            //Building JSON for payment request.
            let cardData = {
                "receiptId": data.receiptId,
                "workOrderId": data.workOrderId,
                "insuranceCompanyId": data.insuranceCompanyId,
                "bank": "",
                "cardNumber": "",
                "cvv": "",
                "ownerCardName": "",
                "endDateMonth": "",
                "endDateYear": "",
                "amount": data.totalPremium,
                "cardType": "",
            }
            //Only sending the JSON starting the component if the insuranceCompany is for Afirme || Chubb.
            if (data.insuranceCompanyId === 377 || data.insuranceCompanyId === 2) {
                postPayment(cardData).then(response => {
                    //In the IH we return to Consultas Page.
                    window.location = '/#/consulta';
                    //But also opens an external tab to the external page of the respective insurance.
                    return window.open(response.reference, "_blank");
                }).catch(() => {
                    Swal.fire({
                        icon: 'error',
                        iconColor: 'var(--skrSecondary)',
                        title: 'No es posible redireccionar',
                        backdrop: `rgba(71, 10, 104, .75)`,
                        allowOutsideClick: false,
                        text: 'Contacta a tu ejecutivo',
                        confirmButtonColor: 'var(--skrSecondary)',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            //If there is an error we return to the Consultas Page.
                            window.location = '/#/consulta';
                        }
                    });
                });
            }
        })
        //setIsLoading(false);


    }, []);

    return (
        <>
            {/* If someone refresh the page when the payment has been succeeded we don´t let  them pay again
             hidding the PaymentForm.
             */}
            {receiptData.status !== "Pendiente" ?
                <div hidden={showError}>
                    <h4 className="text-danger text-center m-5"><b>Error:</b> El pago del recibo ya fue realizado.</h4>
                </div> :

                <>
                    <div className="container-fluid my-5">
                        <div className="row justify-content-center">
                            <div className="col-5">
                                <h5 className="montserratMedium mx-4">Realiza el pago de tu seguro </h5>
                                <div className="container my-5 px-4 py-5 card-border" style={{height: '22rem'}}>
                                    {/* Payment Card Form Component. Needs formikValues & receiptData for building JSON request
                                at submit action, and able or disable button for submit inside the Card,
                                (in this case we don´t need it) */}
                                    <PaymentCardForm formikInitialValues={cardValues}
                                                     receiptData={receiptData} isSubmitOn={false} />

                                </div>
                            </div>
                            <div className="col-4">
                                <h5 className="montserratMedium mx-4">Detalles de pago </h5>
                                <div className="container text-center my-5 p-1 card-border montserratMedium" style={{color: 'var(--skrGray2)', height : '22rem'}}>
                                    <div className="row justify-content-center mx-5 mt-5">
                                        <div className="col p-1">
                                            <b>No. Recibo:</b> {receiptData.receiptNumber}
                                        </div>
                                    </div>
                                    <div className="row justify-content-center mx-5">
                                        <div className="col p-1">
                                            <b>Prima Total: </b>
                                            ${receiptData.totalPremium?.toLocaleString('en', {maximumFractionDigits: 2})} MXN
                                        </div>
                                    </div>
                                    <div className="row justify-content-center mx-5">
                                        <div className="col p-1">
                                            <b>Monto Pagado: </b>
                                            ${receiptData.amountPaid?.toLocaleString('en', {maximumFractionDigits: 2})} MXN
                                        </div>
                                    </div>
                                    <div className="row justify-content-center mx-5">
                                        <div className="col p-1">
                                            <b>Monto Pendiente: </b>
                                            ${receiptData.pendingAmount?.toLocaleString('en', {maximumFractionDigits: 2})} MXN
                                        </div>
                                    </div>

                                    <div className="mt-5 text-center">
                                        <button type="submit" form="paymentForm"
                                                className="btn btn-submit"
                                                disabled={props.userPermissions[3] !== 1}>
                                            Realizar mi pago
                                        </button>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>


                </>
            }
        </>);
}